import { getBackendUrl } from "@Utils";
import * as Sentry from "@Sentry";

export const SignTypeValues = {
  TYPE_NAME_INITIAL: "TYPE_NAME_INITIAL",
  DRAW_ON_SCREEN: "DRAW_ON_SCREEN",
  IMPORT_AS_IMAGE: "IMPORT_AS_IMAGE",
  EMBED_INSIDE_FILE: "EMBED_INSIDE_FILE",
  ATTACH_SIGNED_DOCUMENT: "ATTACH_SIGNED_DOCUMENT",
  IMPORT_PROFILE_SIGNATURE: "IMPORT_PROFILE_SIGNATURE",
};

export const SignTypes = [
  // {
  //   name: "Type Name or Initials",
  //   value: SignTypeValues.TYPE_NAME_INITIAL
  // },
  {
    name: "Draw On Screen",
    value: SignTypeValues.DRAW_ON_SCREEN,
  },
  // {
  //   name: "Import as image",
  //   value: SignTypeValues.IMPORT_AS_IMAGE
  // }, {
  //   name: "Embed inside file",
  //   value: SignTypeValues.EMBED_INSIDE_FILE
  // },
  {
    name: "Attach Signed Document",
    value: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
  },
  {
    name: "Import Profile Signature",
    value: SignTypeValues.IMPORT_PROFILE_SIGNATURE,
  },
];
// The three id sources a schedule task can carry, in priority order.
/** The id-bearing fields this looks for; callers hand over whole task/activity rows, none of
 * which declare all three, so the parameter stays `object` and each read is asserted. */
type TaskIdFields = { WBSCode?: string; customTaskId?: string; scheduleCounter?: number | string };

export const getTaskId = (taskData?: object) => {
  let taskId;
  if ((taskData as TaskIdFields | undefined)?.WBSCode) {
    taskId = `${(taskData as TaskIdFields | undefined)?.WBSCode}`;
  } else if ((taskData as TaskIdFields | undefined)?.customTaskId) {
    taskId = `${(taskData as TaskIdFields | undefined)?.customTaskId}`;
  } else {
    const counter = (taskData as TaskIdFields | undefined)?.scheduleCounter ?? "0";
    taskId = `TSK-${String(counter).padStart(4, "0")}`;
  }
  return taskId;
};
export const getUrlForImage = (data: { id?: string } | null | undefined, type = "profile") => {
  const id = data?.id;
  if (!id || id === "undefined" || id === "null") {
    Sentry.captureException(new Error(`getUrlForImage called without a valid id (type: ${type}, id: ${id})`));
    return "";
  }
  return `${getBackendUrl()}/fileSystemServer/getImage/${type}/${id}`;
};

export const defaultFeedbackToastComponentProps = {
  position: {
    X: "Right",
    Y: "Bottom",
  },
  timeOut: 3000,
  width: 400,
  content: "<div>Your message has been <b>sent</b> successful.</div>",
  title: "",
  isActionButton: false,
  actionBtnText: "UNDO",
};
